import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import Dialog from '../../../molecules/Dialog';
import RatingHalfCardContent from './RatingHalfCardContent';
import FeedBackCard from './FeedBackCard';
import Loader from '../../../atoms/Loader';
import { ModalDataType } from '../types';

import styles from './index.pcss';
import { deleteImageReview } from '../../../../actions/ratings';

const cx = classNames.bind(styles);

interface RatingHalfCardProps {
  displayModal: boolean;
  modalData: ModalDataType;
  productRating: number;
  displayLoader: boolean;
  hideModal: () => void;
  updateModal: (modalName: string, {}) => void;
  fromFleek?: boolean;
}

const RatingHalfCard = (props: RatingHalfCardProps) => {
  const {
    displayModal,
    hideModal,
    productRating,
    modalData,
    updateModal,
    displayLoader,
    deleteImageReview = () => {}
  } = props;
  const { pageToDisplay, isFromPDP = false, displayFeedBackPage = true } = modalData;
  const [displayContent, setDisplayContent] = useState(pageToDisplay);
  const [imageData, setImageData] = useState([]);

  useEffect(() => {
    setDisplayContent(pageToDisplay);
  }, [pageToDisplay]);

  const goToFeedBackPage = () => {
    if (displayFeedBackPage) {
      updateModal('rating-halfcard', {
        state: {
          ...modalData,
          pageToDisplay: 'feedbackCard'
        }
      });
    } else {
      hideModal();
    }
  };

  const retryClickHandler = () => {
    updateModal('rating-halfcard', {
      state: {
        ...modalData,
        rating: 0,
        isFeedBackSubmitted: true,
        isfromWriteFeedBack: true
      }
    });
  };

  return (
    <Dialog
      showDialog={displayModal}
      type="drawer"
      customClass={cx('dialog-container')}
      onCancel={hideModal}
      displayContent={displayContent}
      isFromPDP={isFromPDP}
      ariaLabel="Update Feedback"
    >
      {displayLoader && <Loader />}
      {displayContent === 'ratingHalfCard' && (
        <RatingHalfCardContent
          productRating={productRating}
          modalData={modalData}
          goToFeedBackPage={goToFeedBackPage}
          hideModal={hideModal}
          updateModal={updateModal}
          retryClickHandler={retryClickHandler}
          setReviewAndImageIds={setImageData}
        />
      )}

      {displayContent === 'feedbackCard' && (
        <FeedBackCard
          updateModal={updateModal}
          modalData={modalData}
          hideModal={hideModal}
          isFromPDP={isFromPDP}
        />
      )}
    </Dialog>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    deleteImageReview: (reqObj = {}) => dispatch(deleteImageReview(reqObj))
  };
};

export default connect(null, mapDispatchToProps)(RatingHalfCard);
